import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Textarea from 'react-textarea-autosize';
import {
  FormGroup,
  FormFeedback,
  Label,
  Input,
} from 'reactstrap';

import ErrorBoundary from '../../ErrorBoundary';

import { slugify } from '../../../helpers';

const AdminUserEditUserFields = ({
  userFields,
  profile,
  errors,
  inRegistration,
  handleChange,
}) => (
  <ErrorBoundary>
    {userFields
      .filter((uf => ((inRegistration && uf.in_registration) || !inRegistration)))
      .map((userField) => {
        const fieldName = `userField${userField.id}`;
        const fieldValue = (profile && profile.fields) ?
          profile.fields.find(f => f.id === userField.id) : null;

        return (
          <FormGroup key={userField.id}>
            <Label for={`inpUserField${userField.id}`}>
              {userField.name}
              {(inRegistration && userField.in_registration_required) && ' *'}
            </Label>

            {userField.type === 'text' && (
              <Input
                type="text"
                name={fieldName}
                id={`inpUserField${userField.id}`}
                placeholder={userField.name}
                defaultValue={fieldValue ? fieldValue.value : ''}
                invalid={Boolean(errors[fieldName])}
                onChange={handleChange}
              />
            )}

            {userField.type === 'textarea' && (
              <Textarea
                name={fieldName}
                id={`inpUserField${userField.id}`}
                className={`form-control${errors[fieldName] ? ' is-invalid' : ''}`}
                defaultValue={fieldValue ? fieldValue.value : ''}
                onChange={handleChange}
              />
            )}

            {userField.type === 'select' && (
              <Input
                type="select"
                className="custom-select"
                name={fieldName}
                id={`inpUserField${userField.id}`}
                placeholder={userField.name}
                defaultValue={fieldValue ? fieldValue.value : ''}
                invalid={Boolean(errors[fieldName])}
                onChange={handleChange}
              >
                <option value="">-- select --</option>
                {userField.values.map(v => (
                  <option key={slugify(v)} value={v}>{v}</option>
                ))}
              </Input>
            )}

            {errors[fieldName] && (
              <FormFeedback>{errors[fieldName]}</FormFeedback>
            )}
          </FormGroup>
        );
      })}
  </ErrorBoundary>
);

const mapStateToProps = state => ({
  userFields: state.App.userFields,
});

AdminUserEditUserFields.propTypes = {
  userFields: PropTypes.array.isRequired,
  profile: PropTypes.object,
  errors: PropTypes.object.isRequired,
  inRegistration: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
};

AdminUserEditUserFields.defaultProps = {
  profile: null,
  inRegistration: false,
};

export default connect(mapStateToProps)(AdminUserEditUserFields);
